require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./does-it-look-difficult-or-should-i-just-say-no.json") })
        }
      }, "path---does-it-look-difficult-or-should-i-just-say-no");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---does-it-look-difficult-or-should-i-just-say-no!./.cache/json/does-it-look-difficult-or-should-i-just-say-no.json
// module id = 1086
// module chunks = 231608221292675